import React from "react";
import { Card } from "antd";
import { FaAward, FaCircleInfo, FaHandSparkles, FaInfo } from "react-icons/fa6";


const RatingReference = (  ) => {
    const ratingScale = [
    {
      label: "Exceeds",
      class: "exceeds",
      text: "Performs above expectations. Leads by example and consistently adds extra value.",
    },
    {
      label: "Meets",
      class: "meets",
      text: "Performs well and consistently meets expectations. Reliable and professional.",
    },
    {
      label: "Needs improvement",
      class: "developing",
      text: "Making progress but still growing skills or consistency in some areas.",
    },
    {
      label: "Does not meet expectations",
      class: "needs-focus",
      text: "Below expectations. Requires coaching, support, or clear improvement.",
    },
  ];
   
  return (
      <Card className="flex border-2 border-slate-200 rounded-xl dark:bg-intsamis-900">
        <div className="flex items-center gap-2 mb-6">
            <FaCircleInfo
            size={20}
            className="text-blue-400"/>
            <p className="text-[16px] dark:text-white">Rating Scale Reference</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                {ratingScale.map(({ label, class: className, text }) => (
                  <div
                    key={label}
                    className="flex flex-col text-xs p-3 rounded-lg border gap-1 items-start dark-mode-card"
                  >
                    <span className={`status-indicator ${className}`}>{label}</span>
                    <p className="text-[11px] dark:text-white">{text}</p>
                  </div>
                ))}
        </div>
      </Card>
  );
};

export default RatingReference;